import React from 'react';
import Post from 'components/Post';

const PostPage = () => {

  return (
   <>
    <div className="text-center mb-[48px]">
            <h1 className="text-lg sm:text-2xl  mb-[18px] font-bold">Le Kink</h1>
            <p className="text-base sm:text-base mt-1"> Sofia | I like when things get weird </p>
        </div>
        <div> 
          <Post/>
        </div>
    </>
  );
};

export default PostPage;

